<script>
  let { options = [], group = $bindable(null), name } = $props()
</script>

<div class="boolean-container">
  {#each options as option (option.value)}
    <label class="boolean-segment inline-flex" for={option.value}>
      <input type="radio" name={name} id={option.value} value={option.value} bind:group />
      <span class="px-3">{option.label}</span>
    </label>
  {/each}
</div>